"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsQueryGroupByItem = void 0;
exports.AnalyticsQueryGroupByItem = {
    Type: "type",
    AssistantId: "assistantId",
    EndedReason: "endedReason",
    AnalysisSuccessEvaluation: "analysis.successEvaluation",
    Status: "status",
};
